<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="zeroStateRows"
      styleClass="vgt-table striped"
      row-style-class="blur-row"
      style="width: 100%;"
    >
      <template slot="emptystate">
        <span>
          There are not items to display
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
export default {
  name: 'GroupOrderListZeroState',
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: 'Date',
          field: 'createdAt'
        },
        {
          label: 'Redemption Page',
          field: 'uuid'
        },
        {
          label: 'Creator',
          field: 'email'
        },
        {
          label: 'Submission',
          field: 'submissions'
        },
        {
          label: 'Status',
          field: 'status'
        },
        {
          label: 'Details',
          field: 'details'
        }
      ],
      zeroStateRows: []
    }
  }
}
</script>

<style lang="scss" scoped>
h5 {
  margin: 3rem;
}
</style>
